"use client";

import useSWR from "swr";
import MoreItems, { MoreItemsCard } from "./more-items";
import MoreItemsSkeleton from "./more-items.skeleton";
import { getRecentArticlesExcept } from "@/lib/builder-utils";
import { builder } from "@builder.io/sdk";
import {
  calculateBuilderWordCount,
  calculateTimeToRead,
  withUrl,
} from "@/lib/utils";

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

export type MoreItemsControlledProps = {
  blogId: string;
  title?: string;
  isEditing?: boolean;
};

const MoreItemsControlled: React.FC<MoreItemsControlledProps> = ({
  blogId,
  title = "Recent Articles",
  isEditing,
}) => {
  const fetcher = async ([_]: [string]) =>
    await getRecentArticlesExcept(builder, blogId);

  const { data, isLoading } = useSWR([`recent-articles-${blogId}`], fetcher);

  const cards: MoreItemsCard[] = data
    ?.map((blog) => ({
      title: blog.data?.blogPostTitle ?? "",
      titleHref: withUrl(`${blog.data?.url}`),
      text: blog.data?.blogPostBlurb ?? "",
      image: {
        src: blog.data?.banner?.image ?? "",
        alt: blog.data?.banner?.altText ?? "",
      },
      leftInfo: `By ${blog.data?.author?.value?.name}`,
      rightInfo: `${calculateTimeToRead(
        calculateBuilderWordCount(blog.data?.blocks)
      )} min read`,
    }))
    .filter(Boolean) as MoreItemsCard[];

  if (isLoading || isEditing) return <MoreItemsSkeleton />;

  return (
    <MoreItems
      title={title}
      cards={cards}
    />
  );
};

export default MoreItemsControlled;
